import React, { Component } from 'react';

class IconInformationBlue extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="none"
                viewBox="0 0 32 32"
            >
                <path
                    fill="#26A"
                    d="M17.302 20.69c-.126 0-.236-.033-.278-.086-.034-.043-.05-.117-.05-.223 0-.17.008-.426.058-.649.203-.957.414-1.904.625-2.85.168-.734.202-1.33.135-1.904-.119-.872-.827-1.574-1.654-1.638-.743-.053-1.393.245-2.026.532l-.228.106a.558.558 0 00-.295.373c-.042.17-.076.34-.101.51l-.152.766.49-.128c.092-.021.177-.053.261-.074.16-.054.32-.096.49-.107.177-.01.312.011.37.085.06.075.051.245.043.33a12.32 12.32 0 01-.211 1.319c-.068.35-.152.702-.236 1.042-.177.723-.363 1.478-.405 2.276-.034.766.194 1.372.675 1.808.371.33.784.49 1.266.49a2.7 2.7 0 00.633-.086c.362-.085.7-.244 1.037-.393.127-.053.254-.117.38-.17a.6.6 0 00.304-.383c.034-.15.067-.298.093-.447l.143-.713-.768.117a1.96 1.96 0 01-.599.096zM16.672 12a2 2 0 100-4 2 2 0 000 4z"
                ></path>
                <path
                    fill="#26A"
                    fillRule="evenodd"
                    d="M15.987 0C24.832-.013 32.013 7.158 32 16.006 31.987 24.854 24.857 31.987 16.013 32 7.18 32.026-.013 24.84 0 15.994.013 7.158 7.143.013 15.987 0zm.026 3.186C8.986 3.173 3.21 8.926 3.185 15.98c-.026 7.029 5.711 12.794 12.79 12.846 7.013.052 12.84-5.765 12.84-12.82 0-7.043-5.75-12.808-12.802-12.821z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconInformationBlue;